import React from 'react';
import { Route, Routes } from 'react-router-dom';
// import NotFound from '../views/notfound';
import CMS from './Components/CMS/CMS'
import ROUTES_ENUM from './Constants/routesEnum'

/**
 * Defines components to routes mapping.
 *
 * Everytime a new view is created, entry is required here to map the component to a specific route.
 *
 * [IMPORTANT]
 * All route entries are required to be done before the notFound component.
 *
 * @returns {XML}
 */
export default function router() {
  return (
    <Routes>
      <Route path="/" element={<CMS />} />
      <Route path={ROUTES_ENUM.alerts.pathname} element={<CMS />} />
      <Route path={ROUTES_ENUM.resources.pathname} element={<CMS />} />
      {/* <Route path="/schedule" element={<Dashboard />} />
      <Route path="*" element={<NotFound />} /> */}
    </Routes>
  );
}
